import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "statistics-container"
}
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-item" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "keyCustomerFilter" }, "Key Customers", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "filter-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "fromDate" }, "From Date", -1)
const _hoisted_8 = { class: "filter-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "toDate" }, "To Date", -1)
const _hoisted_10 = { class: "filter-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "keyCustomerFilter" }, "Work Types", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "chart-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chart = _resolveComponent("chart")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("select", {
              id: "keyCustomerFilter",
              multiple: "",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyCustomerFilter) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distinctKeyCustomers, (customer) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: customer,
                  value: customer
                }, _toDisplayString(customer), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.keyCustomerFilter]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "fromDate",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fromDate) = $event))
            }, null, 512), [
              [_vModelText, _ctx.fromDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              id: "toDate",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.toDate) = $event))
            }, null, 512), [
              [_vModelText, _ctx.toDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("select", {
              id: "keyCustomerFilter",
              multiple: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.workTypeFilter) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distinctWorkTypes, (workType) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: workType,
                  value: workType
                }, _toDisplayString(workType), 9, _hoisted_12))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.workTypeFilter]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_ctx.smsOverTime)
            ? (_openBlock(), _createBlock(_component_chart, {
                key: 0,
                options: _ctx.smsOverTime
              }, null, 8, ["options"]))
            : _createCommentVNode("", true),
          (_ctx.frequentlyAskedQuestions)
            ? (_openBlock(), _createBlock(_component_chart, {
                key: 1,
                options: _ctx.frequentlyAskedQuestions
              }, null, 8, ["options"]))
            : _createCommentVNode("", true),
          (_ctx.sentSmsByCustomer)
            ? (_openBlock(), _createBlock(_component_chart, {
                key: 2,
                options: _ctx.sentSmsByCustomer
              }, null, 8, ["options"]))
            : _createCommentVNode("", true),
          (_ctx.checkedProgressPerDay)
            ? (_openBlock(), _createBlock(_component_chart, {
                key: 3,
                options: _ctx.checkedProgressPerDay
              }, null, 8, ["options"]))
            : _createCommentVNode("", true),
          (_ctx.contactEventsByDay)
            ? (_openBlock(), _createBlock(_component_chart, {
                key: 4,
                options: _ctx.contactEventsByDay
              }, null, 8, ["options"]))
            : _createCommentVNode("", true),
          (_ctx.contactEvents)
            ? (_openBlock(), _createBlock(_component_chart, {
                key: 5,
                options: _ctx.contactEvents
              }, null, 8, ["options"]))
            : _createCommentVNode("", true),
          (_ctx.workTypeDistribution)
            ? (_openBlock(), _createBlock(_component_chart, {
                key: 6,
                options: _ctx.workTypeDistribution
              }, null, 8, ["options"]))
            : _createCommentVNode("", true),
          (_ctx.caseUpdateNotificationDistribution)
            ? (_openBlock(), _createBlock(_component_chart, {
                key: 7,
                options: _ctx.caseUpdateNotificationDistribution
              }, null, 8, ["options"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}